import React, { useCallback, useRef, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Box } from "@mui/material";

import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Menu from "@mui/material/Menu";
import AddToShowcaseMenuItems from "./AddToShowcaseMenuItems";

const useStyles = makeStyles(theme => ({
  menu: {
    borderRadius: "5px",
    boxShadow: "0px 0px 30px rgba(149, 169, 177, 0.3)",
    width: "400px",
    overflow: "hidden",
  },

  list: {
    height: "390px",
  },
}));

const AddToShowcaseMenu = ({ moduleId, showcaseItems, onAddClicked }) => {
  const classes = useStyles();

  const handleAddItems = useCallback(
    items => {
      onAddClicked(items);
      setOpenMenu(false);
    },
    [onAddClicked],
  );

  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const toggleMenu = () => setOpenMenu(!openMenu);
  const closeMenu = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenMenu(false);
  };

  const handleListKeyDown = event => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenMenu(false);
    }
  };

  return (
    <Box display="flex" justifyContent="end">
      <Button
        ref={anchorRef}
        onClick={toggleMenu}
        startIcon={<AddIcon />}
        aria-controls={openMenu ? `add-to-showcase-drop-down` : undefined}
        aria-haspopup="true"
        disableRipple
        style={{
          backgroundColor: openMenu && "rgba(0, 0, 0, 0.04)",
        }}
      >
        Add to Showcase
      </Button>
      <Menu
        open={openMenu}
        onClose={closeMenu}
        anchorEl={anchorRef.current}
        id={`add-to-showcase-drop-down`}
        onKeyDown={handleListKeyDown}
        classes={{
          paper: classes.menu,
        }}
        MenuListProps={{
          classes: {
            root: classes.list,
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div>
          <AddToShowcaseMenuItems
            open={openMenu}
            moduleId={moduleId}
            showcaseItems={showcaseItems}
            onAddClicked={handleAddItems}
          />
        </div>
      </Menu>
    </Box>
  );
};

export default AddToShowcaseMenu;
